import { UserProfile } from 'fitbeat.gym-core';
import { IHeartRate } from 'fitbeat.models';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import CurrentConnectedAppHeartRateBanner from './CurrentConnectedAppHeartRateBanner';
import { themeStyleMapper } from './HeartRateMonitorSetup';
import { maskIdentifierIfTigernova } from '../utils/BluetoothService';
import {
    Button,
    ButtonTypes,
} from '../../components';
import Theme, { ThemeType } from '../../theme';
import { ConnectingLoaderIcon } from '../../ui/components';
import { defaultScale } from '../../utils/scaling';

interface IProps {
    themeType: ThemeType;
    isScanningBelt: boolean;
    heartRateRecievedError: string | null;
    userProfile: UserProfile;
    isRemovingHeartRateIdentifier: boolean;
    isSavingHeartRateIdentifier: boolean;
    heartRateMonitorDisconnected: boolean;
    latestConnectedAppHR: IHeartRate | null;
    t: (key: string) => string;
    testBelt(beltNumber?: string): void;
    showFaq(): void;
}

export class MonitorConnecting extends React.PureComponent<IProps, any>  {
    public render() {
        const { t, testBelt,
            isScanningBelt, isRemovingHeartRateIdentifier, heartRateRecievedError, heartRateMonitorDisconnected,
            latestConnectedAppHR,
            showFaq,
            userProfile, isSavingHeartRateIdentifier, themeType = ThemeType.light } = this.props;
        const themeStyle = themeStyleMapper[themeType];

        return (
            <View style={styles.outerContainer}>
              <CurrentConnectedAppHeartRateBanner
                latestConnectedAppHR={latestConnectedAppHR}
                t={t}
                themeType={themeType}
                showFaq={showFaq}
              />
              <View style={styles.wrappingContainer}>
                <View style={styles.scanningContainer}>
                    <View style={styles.iconContainer}>
                        <ConnectingLoaderIcon width={defaultScale(100)} height={defaultScale(100)}
                            animating={!heartRateRecievedError && !heartRateMonitorDisconnected}
                            color={themeStyle.iconColor2.color} />
                    </View>

                    {!heartRateRecievedError && !heartRateMonitorDisconnected && !isRemovingHeartRateIdentifier &&
                        <Text style={[styles.scanDescriptionText, themeStyle.textColor1]}>
                            {t('tryConnectMonitor')}
                        </Text>
                    }

                    {isRemovingHeartRateIdentifier &&
                        <Text style={[styles.scanDescriptionText, themeStyle.textColor1]}>
                            {t('removingDevice')}
                        </Text>
                    }

                    {heartRateRecievedError &&
                        <Text style={[styles.scanDescriptionText, themeStyle.textColor1]}>
                            {heartRateRecievedError}
                        </Text>
                    }

                    {heartRateMonitorDisconnected &&
                        <Text style={[styles.scanDescriptionText, themeStyle.textColor1]}>
                            {t('makeSureDeviceActivated')}
                        </Text>
                    }
                </View>

                {(heartRateRecievedError || heartRateMonitorDisconnected) &&
                    <Button
                        title={t('tryAgain')}
                        onPress={() => testBelt(userProfile.heartRateMonitors?.home)}
                        fontColor={Theme.PRIMARY}
                        buttonType={ButtonTypes.TRANSPARENT}
                        containerStyle={[styles.buttonContainer, styles.margin]}
                    />
                }

                <View style={styles.hrIdContainer}>
                    <Text style={[{ ...Theme.textStyle.bodyCopyReg }, styles.center, themeStyle.textColor1]}>
                        {isSavingHeartRateIdentifier
                          ? '...'
                          : maskIdentifierIfTigernova(userProfile.heartRateMonitors?.home)
                        }
                    </Text>
                    <Text style={[{ ...Theme.textStyle.bodyCopyReg }, styles.center, themeStyle.textColor1]}>
                        {(heartRateRecievedError || heartRateMonitorDisconnected) && t('notConnected')}
                    </Text>
                </View>
              </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    outerContainer: {
      flex: 1,
    },
    buttonContainer: {
        flexDirection: 'column',
    },
    wrappingContainer: {
      flexGrow: 1,
      justifyContent: 'center',
    },
    scanningContainer: {
        paddingTop: defaultScale(34),
        paddingBottom: defaultScale(10),
    },
    iconContainer: {
        paddingBottom: defaultScale(20),
        alignSelf: 'center',
    },
    scanDescriptionText: {
        ...Theme.textStyle.heading,
        color: Theme.GREY_DARK_MEDIUM,
        marginHorizontal: defaultScale(22),
        marginBottom: defaultScale(4),
        alignSelf: 'center',
        textAlign: 'center',
    },
    hrIdContainer: {
        marginBottom: defaultScale(60),
    },
    center: {
        alignSelf: 'center',
    },
    margin: {
        marginBottom: defaultScale(10),
    },
});

export default MonitorConnecting;
